// src/pages/circuito/CircuitoRegulamento.js
"use client"

import { useContext } from "react"
import { Link, useParams } from "react-router-dom"
import { CircuitoContext } from "../../context/CircuitoContext"
import { FaHome, FaBook, FaFilePdf, FaDownload } from "react-icons/fa"
import "../../styles/circuitoHomeV2.css"

export default function CircuitoRegulamento() {
  const { slug } = useParams()
  const { circuito, loadingCircuito } = useContext(CircuitoContext)

  if (loadingCircuito) {
    return (
      <div className="ch-section">
        <div className="ch-container">
          <div className="ch-loading">Carregando regulamento...</div>
        </div>
      </div>
    )
  }

  return (
    <div className="ch-page">
      <div className="ch-section">
        <div className="ch-container">
          {/* Breadcrumb */}
          <nav className="ch-breadcrumb">
            <FaHome />
            <Link to={`/circuito/${slug}`}>Início</Link>
            <span>/</span>
            <span>Regulamento</span>
          </nav>

          {/* Header */}
          <div className="ch-page-header">
            <h1>
              <FaBook style={{ marginRight: 12, color: "var(--c-accent)" }} />
              Regulamento
            </h1>
            <div className="ch-page-header__divider" />
          </div>

          {/* NOVO CONTEÚDO ESTILIZADO COM PDF */}
          <div className="ch-article__body" style={{ 
              background: "var(--c-card)", 
              padding: "50px 20px", 
              borderRadius: "16px", 
              textAlign: "center", 
              border: "1px solid rgba(255,255,255,0.05)",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              marginTop: "20px"
          }}>
             <FaFilePdf size={70} color="#ef4444" style={{ marginBottom: 20 }} />
             <h2 style={{ color: "#fff", marginBottom: 15, fontSize: "28px" }}>Regulamento Oficial</h2>
             <p style={{ color: "rgba(255,255,255,0.7)", marginBottom: 40, maxWidth: "600px", margin: "0 auto 40px auto", fontSize: "16px" }}>
               Clique no botão abaixo para visualizar ou baixar o documento oficial em formato PDF contendo todas as regras, pontuações e condutas deste circuito.
             </p>
             
             {circuito?.regulamentoPdf ? (
                <a 
                  href={`https://api.ticketdovaqueiro.com/uploads/${circuito.regulamentoPdf}`} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="ch-btn ch-btn--primary" 
                  style={{ display: "inline-flex", alignItems: "center", gap: 12, fontSize: "18px", padding: "16px 32px", borderRadius: "50px" }}
                >
                  <FaDownload /> Baixar Regulamento em PDF
                </a>
             ) : (
                <div style={{ padding: "20px", background: "rgba(239, 68, 68, 0.1)", color: "#ef4444", borderRadius: "8px", display: "inline-block" }}>
                  O regulamento deste circuito ainda não foi anexado.
                </div>
             )}
          </div>

        </div>
      </div>
    </div>
  )
}